import { useEffect, useState } from "react";
import globalRequest from "../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import { CATEGORIES } from "../../utils/helper/Enum";
import * as CUSTOM from "../../utils/helper/custom";
import MenuItems from "components/MenuBar/MenuItems";
import {
  updateCategories,
  getAllCategories,
} from "../../redux/reducers/allCategories";
import { useNavigate } from "react-router-dom";
const NavMenu = (props) => {
  const dispatch = useDispatch();
  const [menuItems, setMenuItem] = useState([]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const getAllCatData = useSelector(getAllCategories);

  /**
   *  Get category list
   */
  const getAllCategoriesList = async () => {
    try {
      //dispatch(changeLoader(true));
      let response = await globalRequest(
        CATEGORIES?.GET_ALL_CATEGORIES,
        "get",
        {},
        {},
        true
      );

      response = response?.data;

      if (response?.status === "SUCCESS") {
        const categories = response?.data || [];
        const categoriesWithUrls = categories.map(mainCat => {
          const mainSlug = mainCat.slug;
          const mainUrl = `/${mainSlug}`;

          const subcategories = mainCat.subcategories?.map(subCat => {
            const subSlug = `${mainSlug}/${subCat.slug}`;
            const subUrl = `/${subSlug}`;

            const subsubcategories = subCat.subsubcategories?.map(subSubCat => ({
              ...subSubCat,
              fullUrl: `/${subSlug}/${subSubCat.slug}`
            })) || [];

            return {
              ...subCat,
              fullUrl: subUrl,
              subsubcategories,
            };
          }) || [];

          return {
            ...mainCat,
            fullUrl: mainUrl,
            subcategories,
          };
        });
        dispatch(updateCategories(categoriesWithUrls));
      }

      dispatch(changeLoader(false));
    } catch (e) { }
  };

  const navigate = useNavigate();

  
  let urlPath = '';
  const handleCategoryClick = (category) => {
    urlPath = category;
    navigate(category);
    
  };


  useEffect(() => {
    if (getAllCatData.length == 0) {
      getAllCategoriesList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const processCategories = (categories, parentSlug = '') => {
      return categories.map((item) => {
        const slugPath = parentSlug ? `${parentSlug}/${item.slug}` : item.slug;
        const url = `/productlist/${slugPath}/${item.id}`;

        const mainObj = {
          title: CUSTOM.toTitleCase(CUSTOM.getdataByLangKey(item?.categoryLocales, "", "name")),
          url,
          id: item?.id,
        };

        if (item?.subcategories?.length > 0) {
          mainObj.submenu = item.subcategories.map((sitem) => {
            const subObj = {
              title: CUSTOM.toTitleCase(CUSTOM.getdataByLangKey(sitem?.categoryLocales, "", "name")),
              url: sitem?.parentId > 0 ? `/productlist/${slugPath}/${sitem?.slug}/${sitem?.id}` : "",
              id: sitem?.id,
            };

            if (sitem?.subsubcategories?.length > 0) {
              subObj.submenu = sitem.subsubcategories.map((ssitem) => ({
                title: CUSTOM.toTitleCase(CUSTOM.getdataByLangKey(ssitem?.categoryLocales, "", "name")),
                url: ssitem?.parentId > 0 ? `/productlist/${slugPath}/${sitem?.slug}/${ssitem?.slug}/${ssitem?.id}` : "",
                id: ssitem?.id,
              }));
            }

            return subObj;
          });
        }

        return mainObj;
      });
    };

    const isMobile = windowWidth < 768;
    let allMenuItems = [];

  if (getAllCatData.length > 0) {
    if (isMobile) {
      allMenuItems = processCategories(getAllCatData);
    } else {
      allMenuItems = processCategories(getAllCatData.slice(0, 5));
    if (getAllCatData.length > 5) {
      allMenuItems.push({
        title: "More",
        url: "",
        id: 0,
        submenu: processCategories(getAllCatData.slice(5)),
      });
    }
    }
  }

    setMenuItem(allMenuItems);
  }, [getAllCatData, windowWidth]);
  return (
    <>
      <nav className={`${props.navStyles} flex flex-row mobile-menu-parent`}>
        <ul className="menus">
          {menuItems.map((menu, index) => {
            const depthLevel = 0;
            return (
              <MenuItems
                handlehamburger={props.handlehamburger}
                items={menu}
                key={index}
                depthLevel={depthLevel}
                handleCategoryClick={handleCategoryClick}
                urlPath={urlPath}
              />
            );
          })}
        </ul>
      </nav>
    </>
  );
};

export { NavMenu };
